/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { UPDATE_LOAN_HISTORY_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(UPDATE_LOAN_HISTORY_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((payload) =>
      AjaxRequest.open(
        'put',
        `/admin/loanhistorycustom/loanhistories/${payload.loanHistoryId}/update`,
        payload,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
